// extracted by mini-css-extract-plugin
export default {"Story":"UserItem_Story__C7Onb","description":"UserItem_description__p+G2t","price":"UserItem_price__JYJnC"};